import * as yup from "yup";

export const adicionarCustoSchema = yup.object({
  servico: yup
    .number()
    .moreThan(0, "O custo é obrigatório")
    .required("O custo é obrigatório"),
  valor: yup
    .string()
    .typeError("O valor é obrigatório")
    .required("O valor é obrigatório")
    .test("valor", "O valor é obrigatório", (value) => {
      return !["", "0.00"].includes(value);
    }),
});
